import { render, staticRenderFns } from "./Pillar4.vue?vue&type=template&id=589b840f&"
import script from "./Pillar4.vue?vue&type=script&lang=js&"
export * from "./Pillar4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports